import { render, staticRenderFns } from "./AnonUserView.vue?vue&type=template&id=568dba1a"
import script from "./AnonUserView.vue?vue&type=script&lang=js"
export * from "./AnonUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports